module.exports = "/images/Obstacle Course.svg?ec483a29f82b5c03aad0da436cc4adf9";